<template>
  <div class="contact-form-section section-space--ptb_120" id="contact">
    <div class="container">
      <div class="row">
        <div class="col-lg-7 order-2 order-lg-1">
          <div class="section-title text-center mb-4">
            <h2 class="font-weight--bold mb-15 wow move-up">Kontaktieren Sie uns gerne bei Fragen!</h2>
            <span class="section-text_left wow move-up">Bitte füllen Sie dafür das Formular aus. Wir melden uns zeitnah bei Ihnen.</span>
          </div>
          <div class="contact-from-wrapper wow move-up">
            <form v-if="!mailWasSent" id="contact-form" @submit.prevent="sendMail">
              <div v-if="0 < errors.length" class="alert alert-danger" role="alert">
                <ul v-for="(error, key) in errors" :key="key">
                  <li>{{ error }}</li>
                </ul>
              </div>
              <div class="contact-page-form">
                <div class="contact-input">
                  <div class="contact-inner">
                    <input v-model="payload.givenName" name="con_first_name" type="text" placeholder="Vorname *" required>
                  </div>
                  <div class="contact-inner">
                    <input v-model="payload.familyName" name="con_last_name" type="text" placeholder="Nachname *" required>
                  </div>
                </div>
                <div class="contact-input">
                  <div class="contact-inner">
                    <input v-model="payload.email" name="con_email" type="email" placeholder="Email *" required>
                  </div>
                  <div class="contact-inner">
                    <input v-model="payload.phone" name="con_phone" type="tel" placeholder="Telefonnummer *" required>
                  </div>
                </div>
                <div class="contact-inner">
                  <input v-model="payload.subject" name="con_subject" type="text" placeholder="Betreff *" required>
                </div>
                <div class="contact-inner contact-message">
                  <textarea v-model="payload.message" name="con_message" placeholder="Ihre Nachricht *" required></textarea>
                </div>
                <div class="contact-submit-btn">
                  <button class="ht-btn ht-btn-md" type="submit">
                    <fa-icon v-if="loading" class="mr-2" :icon="['fas', 'spinner']" />
                    Nachricht versenden
                  </button>
                  <p class="form-messege"></p>
                </div>
              </div>
            </form>
            <div v-else class="contact-page__mail-sent">
              <h5>Wir haben Ihre Nachricht erhalten!</h5>
              <p>Wir melden uns so schnell wie möglich.</p>
              <img src="../assets/img/banners/mail_sent.png" class="img-fluid" alt="">
            </div>
          </div>
        </div>
        <div class="col-lg-5 order-1 order-lg-2 flex align-items-center">
          <div class="peatures_image-wrap section-space--mb_40">
            <div class="image text-center wow move-up">
              <img class="img-fluid" src="../assets/img/features/contacts.svg" alt="contact thumb">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUrl } from '@/config.js'

export default {
  name: 'ContactForm',
  data() {
    return {
      errors: [],
      loading: false,
      mailWasSent: false,
      payload: {
        email: '',
        givenName: '',
        familyName: '',
        phone: '',
        subject: '',
        message: ''
      }
    }
  },
  methods: {
    async sendMail() {
      this.errors = []
      let headers = this.getXsrf()
      if (!headers)
        return this.errors.push('Etwas ist schief gelaufen. Bitte probiere es später erneut!')

      this.loading = true
      await this.$axios.post(`${apiUrl}contact`, {
        payload: this.payload
      }, {
        withCredentials: true,
        headers
      }).then(() => {
        this.mailWasSent = true
      }).catch(error => {
        const response = error.response.data
        if (response && response.errors) {
          for (const errors of Object.values(response.errors)) {
            this.errors = this.errors.concat(errors)
          }
        } else {
          this.errors.push('Etwas ist schief gelaufen. Bitte probiere es später erneut!')
        }
      }).finally(() => {
        this.loading = false
      })
    },
    getXsrf() {
      const name = 'XSRF-TOKEN='
      const decodedCookie = decodeURIComponent(document.cookie)
      const ca = decodedCookie.split(';')
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) === ' ') {
          c = c.substring(1)
        }
        if (c.indexOf(name) === 0) {
          return {
            'X-XSRF-TOKEN': c.substring(name.length, c.length)
          }
        }
      }
      return ''
    }
  }
}
</script>

<style lang="sass">
@keyframes rotating
  from
    transform: rotate(0deg)
  to
    transform: rotate(360deg)

.fa-spinner
  animation: rotating 2s linear infinite

.contact-page__mail-sent
  text-align: center
  img
    max-width: 400px
</style>